import { publicFetch } from './request';

export default async function getPageContent(pageType, setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener el contenido de la página.');
    return await publicFetch(`/page-content/${pageType}`, onError);
}
